import React, { useState, useEffect, useMemo } from 'react';
import Cookies from 'js-cookie';
import VariationsIcon from '@mui/icons-material/ViewCarousel';

import Skeleton from '@material-ui/lab/Skeleton';
import SettingsIcon from '@mui/icons-material/Settings';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment'; // Importe a biblioteca Moment.js
import {  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {
    Box,
    Tooltip
} from '@mui/material';
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import {
    MaterialReactTable,

} from 'material-react-table';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import Autocomplete from '@material-ui/lab/Autocomplete';

import api from '../../../../../../services/api';
import NavegadorGestao from "../../../../../../components/NavBarGestao";
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';



function novo() {
    window.location.href = "/gestao/operacional/almoxarifado/estoque/cadastrarentrada"

}

export default function AdicionarEstoque({insumo, closeAdicionarEstoque}) {

    const [loading, setLoading] = useState(true);

     const [armazenamentos, setArmazenamentos] = useState([]);
        const [armazenamentoSelecionado, setArmazenamentoSelecionado] = useState(null);
    const [quantidade, setQuantidade] = useState(0);
    const [descricaoEntradaEstoque, setDescricaoEntradaEstoque] = useState('');

    const [descricaoArmazenamento, setDescricaoArmazenamento] = useState('');

    const currencyFormatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });


    async function listar() {
        setLoading(true);

        try {
            const token = Cookies.get('token');
            const headers = { 'Authorization': 'Bearer ' + token };

                const resArmazenamentos = await api.get('v1/protected/almoxarifado/armazenamento/listar', { headers });
                        setArmazenamentos(resArmazenamentos.data);
                        setLoading(false);
            

        } catch (_err) {
            console.log("Erro ao listar objetos: " + _err);
            setLoading(false);
        }
    }


    useEffect(() => {


        listar();


    }, []);


    
    
        function returnDescricaoUnidade(unidade) {
    
            console.log("unidade: " + unidade);
    
            var nome = unidade.nome_fantasia;
    
            var endereco = unidade.logradouro + ", nº " + unidade.numero + ", " + unidade.bairro + ", " + unidade.cidade + " " + unidade.estado + " CEP: " + unidade.cep;
    
    
            var texto = nome + " | " + unidade.cnpj;
            return texto;
        }
    
 
 function returnDescricaoArmazenamento(armazenamento) {
        try {
            if (!armazenamento || typeof armazenamento !== "object") {
                return "Armazenamento não disponível";
            }



            const {
                descricao = "—",
                sala = "—",
                corredor = "—",
                bloco = "—",
                gondola = "—",
                prateleira = "—",
            } = armazenamento;

            return (
                returnDescricaoUnidade(armazenamento.unidade) + "\n" +
                "Descrição: " + descricao
            );
        } catch (err) {
            console.error("Erro ao gerar descrição do armazenamento:", err);
            return "Erro ao processar dados de armazenamento";
        }
    }

    function resumoArmazenamento(armazenamento) {
        const textoCompleto = returnDescricaoArmazenamento(armazenamento);
        // Retorna até 30 caracteres + "..." se necessário
        return textoCompleto;
        //return textoCompleto.length > 30 ? textoCompleto.substring(0, 30) + "..." : textoCompleto;
    }
   
    const [botaoClicado, setBotaoClicado] = useState(false);


     const salvar = () => {
            // Verifica se o botão já foi clicado
            if (!botaoClicado) {
                // Executa a lógica do clique aqui
                console.log('Botão clicado!');
    
                // Atualiza o estado para indicar que o botão foi clicado
                setBotaoClicado(true);
                funcaoSalvar();
            }
        };
    
    
       async function funcaoSalvar() {
                          setBotaoClicado(true);

        try {
            
             if(quantidade <= 0){
                alert("Insira uma quantidade valida");

                  setBotaoClicado(false);
             }


               
             if(!armazenamentoSelecionado){
                alert("Selecione o Local de Armazenamento");
                setBotaoClicado(false);
             }


              const cadastro = {
                    quantidade: quantidade,
                    id_armazenamento: armazenamentoSelecionado.id_armazenamento,
                    descricao_entrada: descricaoEntradaEstoque,
                    descricao_armazenamento: descricaoArmazenamento,
                    id_insumo: insumo.id_insumo
                   }
            
    
            // 6️⃣ Chamada da API
            const headers = { Authorization: "Bearer " + Cookies.get("token") };
    
            const response = await api.post(
                `/v1/protected/almoxarifado/estoque/adicionaritensnoestoque/${Cookies.get("id_usuario")}`,
                cadastro,
                { headers }
            );
    
            // 7️⃣ Confirmação
            if (response.data) {
                alert("✅ Itens adicionados ao estoque com sucesso!");

                closeAdicionarEstoque();
                
            } else {
                alert("Erro ao adicionar itens ao estoque, consulte o administrador");
            }
    
        } catch (err) {
            console.error("Erro ao cadastrar:", err);
            setBotaoClicado(false);
            alert("Erro de conexão, tente novamente mais tarde");
        }
    }
 

    return (
        <div>
 
            <div style={{ padding: 10, width: '100%', height: '100%' }}>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <div>
                        

  <Grid item xs={12} style={{ padding: 5 }}>
    <TextField
        label="Quantidade"
        type="number"
        fullWidth
        value={quantidade}
        onChange={(e) => setQuantidade(e.target.value)}
        style={{ marginBottom: 10 }}
    />

    <TextField
        label="Descrição da Entrada desse Estoque"
        fullWidth
        value={descricaoEntradaEstoque}
        onChange={(e) => setDescricaoEntradaEstoque(e.target.value)}
         multiline
        minRows={3}
        style={{ marginBottom: 10 }}
    />


    <Grid
                                                    container
                                                    direction="row"
                                                    justifyContent="flex-end"
                                                    align="flex-end"
                                                    item xs={12}
                                                    style={{ marginTop: 1 }}
                                                >
                                                    <Grid
                                                        container
                                                        direction="column"
                                                        justifyContent="center"
                                                        align="center"
                                                        item xs={12}
                                                    >
    
                                                        <Autocomplete
                                                            id="select-armazenamento"
                                                            options={armazenamentos}
                                                            getOptionLabel={(armazenamento) => returnDescricaoArmazenamento(armazenamento).replace(/<br \/>/g, '\n')}
                                                            value={armazenamentoSelecionado}
                                                            onChange={(e, v) => setArmazenamentoSelecionado(v)}
                                                            filterOptions={(options, { inputValue }) => {
                                                                const inputKeywords = inputValue.toLowerCase().split(" ");
                                                                return options.filter((cotacao) => {
                                                                    const cotacaoText = returnDescricaoArmazenamento(cotacao).toLowerCase();
                                                                    return inputKeywords.every((keyword) => cotacaoText.includes(keyword));
                                                                });
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField {...params} label=" Armazenamento " multiline minRows={3} />
                                                            )}
                                                            renderOption={(option) => (
                                                                <div dangerouslySetInnerHTML={{ __html: returnDescricaoArmazenamento(option) }} />
                                                            )}
                                                        />
                                                    </Grid>
                                                </Grid>
    
    

    <TextField
        label="Descrição do Armazenamento"
        fullWidth
        multiline
        minRows={3}
        value={descricaoArmazenamento}
        onChange={(e) => setDescricaoArmazenamento(e.target.value)}
    />
</Grid>



  <Button
                        variant="contained"
                        onClick={() => closeAdicionarEstoque(false)}
                        color="secondary"
                            disabled={botaoClicado}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            salvar();
                        }}
                            disabled={botaoClicado}
                        color="primary"
                    >
                        Finalizar
                    </Button> 
                    </div>
                }



            </div>

 
        </div>
    );
}



